<script>
import FormBlock from '@/components/FormBlock.vue';
import api from '@/api/user';
import daysLeft from '@/utils/daysLeft';
import utils from '@/utils/common';

export default {
  name: 'UserAutopayStatus',
  components: { FormBlock },
  computed: {
    self() { return this.$store.state.auth.user ?? {}; },
    isDisabled() { return this.self.customInfo?.autopay?.disabled === true; },
    isEnabled() { return !!this.self.customInfo?.autopay?.extId; },
    daysLeft() { return daysLeft(this.$store.state.auth.user) - 3; },
    daysLeftStr() { return utils.pluralWord(this.daysLeft, 'день', 'дня', 'дней'); },
    sum() { return (this.self.tariff.pricePerDay * 30) / 100; },
  },
  methods: {
    async disable() {
      const res = await this.$confirm('Вы действительно хотите отключить автоплатеж?');
      if (!res) return;

      api.autopayDisable({}, true)
        .then(() => {
          const user = JSON.parse(JSON.stringify(this.$store.state.auth.user));
          user.customInfo ??= {};
          user.customInfo.autopay = { disabled: true };
          this.$store.commit('auth/setUser', user);
        })
        .catch(() => { this.$alert('Ошибка! Пожалуйста, обратитесь в техническую поддержку.'); });
    },
  },
};
</script>

<template lang="pug">
  .b-autopay-cancel(v-if="isEnabled || isDisabled")
      template(v-if="isDisabled") Автоплатеж отключен
      template(v-if="isEnabled") У Вас подключен автоплатеж. <br> Следующее списание {{ sum }} руб через {{ daysLeftStr }}.
        Btn(@click="disable") Отключить
</template>

<style scoped lang="scss">
  .autopay-cancel {
    display: flex;
    align-items: center;
    gap: 30px;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #33A1FB;
    background: rgba(51, 161, 251, 0.1);
  }
</style>
